import { Component, ElementRef, EventEmitter, forwardRef, Input, Output, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { debounceTime, fromEvent, map, of } from 'rxjs';

@Component({
  selector: 'split-multi-select',
  templateUrl: './split-multi-select.component.html',
  styleUrls: ['./split-multi-select.component.scss'],
  host: {
    class: 'p-element p-inputwrapper',
    '[class.p-inputwrapper-focus]': 'focused || isSelected'
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SplitMultiSelectComponent),
      multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None
})
export class SplitMultiSelectComponent implements ControlValueAccessor {
  @Input() selectionLimit = 3;

  protected _options: { id: string | number, name: string, checked?: boolean}[] = [];
  
  @Input() 
  set options(options: { id: string | number, name: string}[]) {
    console.log(options);
    if(options) this._options = options.map(o => ({ ...o, checked: false }));
  }

  get options() {
    return this._options.map(o => ({id: o.id, name: o.name}));
  }

  @ViewChild('idFilterInput') public filterInput: any;
  @ViewChildren('optionItems') optionItems!: QueryList<ElementRef>;

  @Output() filterChange = new EventEmitter<any>();

  protected selected: { id: string | number, name: string }[] = [];
  protected showOverlay: boolean = false;

  protected get isSelected(){ return this.selected.length > 0 };

  protected get isDisabledChecked(){ 
    return this.selected.length >= this.selectionLimit 
  }

  onChange = (value: any) => {};
  onTouched = () => {};
  disabled = false;

  protected focused: boolean = false;


  writeValue(value: any): void {
    this.selected = value ? [...value] : [];
    this._options.forEach(o => o.checked = this.selected.includes(o));
  }
  registerOnChange(fn: any): void {
     this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
     this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onFilter(event: any) {
    of(event)
      .pipe(
        map((event: any) => event.target.value),
        debounceTime(1000)
      ).subscribe((value: any) => {
        this.filterChange.emit(value);
      })
  }

  toggleSelection(option: any) {
    if (option.checked == false && this.isDisabledChecked) return;

    let index = this._options.findIndex(o => o.id === option.id);
    if (this.selected.includes(option)) {
      this.selected = this.selected.filter(s => s.id !== option.id);
      this._options[index].checked = false;
    } else {
      this.selected = [...this.selected, option];
      this._options[index].checked = true;
    }
    this.onChange(this.selected.length > 0 ? this.selected : null);
  }

  taggleOverlay() {
    if (!this.disabled) {
      this.showOverlay = !this.showOverlay;
      this.onTouched(); 
      this.scrollIntoView();
    }
  }


  onContainerClick(event: any) {
    if (!this.disabled) {
      this.focused = true;
      this.showOverlay = !this.showOverlay;
      this.onTouched(); 
      setTimeout(() => this.scrollIntoView(), 0);
    }
  }

  onHide() {
    this.focused = false;
    this.showOverlay = false;
  }

  scrollIntoView() {
    if (this.selected.length == 0) return;

    const firstSelected = this.selected[0];
    const index = this.options.findIndex(
      (opt) => opt.id === firstSelected.id
    );
    const item = this.optionItems.get(index);
    if (item) {
      item.nativeElement.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

}
